let suf = "tutor/";
export default {
	get(){
		return suf+"get";
	},
	set(){
		return suf+"set";
	},
};
